export default __webpack_public_path__ + "11ecb601807601683ab2172efc4247d3.png";